import React from "react";

import styles from "./Collapsible.module.scss";
import classnames from "classnames";
import { useUi } from "@jelly/lesson";

type CollapsibleTheme = "standard" | "ghost";

interface CollapsibleProps {
  open: boolean;
  title: string;
  children: React.ReactNode;
  onToggle: (open: boolean) => void;
  theme?: CollapsibleTheme;
}
export const Collapsible: React.FC<CollapsibleProps> = ({ open, title, children, onToggle, theme = "standard" }) => {
  const ui = useUi();

  return (
    <div
      className={classnames(styles.root, {
        [styles.open]: open,
        [styles.themeGhost]: theme === "ghost",
        [styles.themeStandard]: theme === "standard",
      })}
    >
      <div className={styles.header} onClick={() => onToggle(open)}>
        <div className={styles.title}>{title}</div>
        <div className={styles.chevron}>
          {theme === "standard" && (
            <ui.Button
              shape={"invisible"}
              theme={"primary"}
              icon={open ? "cis-chevron-circle-down" : "cis-chevron-circle-up"}
            />
          )}
          {theme === "ghost" && (
            <ui.Button
              shape={"invisible"}
              theme={"primary"}
              icon={open ? "cis-chevron-circle-down-alt" : "cis-chevron-circle-up-alt"}
            />
          )}
        </div>
      </div>
      <div className={classnames(styles.contentWrapper)}>{children}</div>
    </div>
  );
};
